import React, { useState } from 'react'
import { bool } from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import isMobile from 'utils/isMobile'
import SignupFormContainer from 'containers/accountAccess/SignupFormContainer'

require('./SignupLogin.scss')

const SignupLogin = ({ isLogin }) => {
    const [taps, setTaps] = useState(0)
    const { t } = useTranslation()

    const shouldShowMobileWarning = isMobile() && taps < 10
    return (
        <div className="SignupLogin">
            {shouldShowMobileWarning ? (
                <div className="mobileWarning" onClick={() => setTaps(taps + 1)}>
                    {t('login.no mobile login')}
                </div>
            ) : (
                <>
                    <div className="signupForm">
                        <h2>{t('login.welcome to sugarcube')}!</h2>
                        <p className="sub">
                            {isLogin ? t('login.log in to access sugarcube') : t('login.sign up to access sugarcube')}
                        </p>
                        <SignupFormContainer isLogin={isLogin} />
                    </div>
                    <p className="accountPrompt">
                        {isLogin ? t('login.need account') : t('login.have account')}
                        <br />
                        {isLogin ? (
                            <Link to="/signup">{t('header.sign up')}</Link>
                        ) : (
                            <Link to="/login">{t('header.log in')}</Link>
                        )}
                    </p>
                </>
            )}
        </div>
    )
}

SignupLogin.propTypes = {
    isLogin: bool.isRequired,
}

export default SignupLogin
